module.exports = __webpack_public_path__ + "static/media/model-s.08671c28.jpg";